import React, { useEffect, useState } from 'react';
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CircularProgress,
  Modal, IconButton
} from '@mui/material';
import axios from '../api'; // Axios instance for API calls
import CloseIcon from '@mui/icons-material/Close';
function Showcases() {
  const [showcases, setShowcases] = useState([]);
  const [sortOrder, setSortOrder] = useState('Newest');
  const [filterType, setFilterType] = useState('All');
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchShowcases = async () => {
      try {
        const response = await axios.get('/showcases');
        console.log('Fetched showcases:', response.data);
        setShowcases(response.data);
      } catch (error) {
        console.error('Error fetching showcases:', error);
      }
    };

    fetchShowcases();
  }, []);

  const handleSortChange = (event) => {
    setSortOrder(event.target.value);
    const sortedShowcases = [...showcases].sort((a, b) => {
      return event.target.value === 'Newest'
        ? new Date(b.created_at) - new Date(a.created_at)
        : new Date(a.created_at) - new Date(b.created_at);
    });
    setShowcases(sortedShowcases);
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const filteredShowcases = showcases.filter((showcase) => {
    if (filterType === 'All') return true;
    if (filterType === 'Outfitters') return showcase.type === 0;
    if (filterType === 'Sportsmen') return showcase.type === 1;
    return true;
  });

  if (!showcases.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4" style={{ color: '#452f0f', fontWeight: 'bold' }}>
          Showcases
        </Typography>
        <Box display="flex" gap={2}>
          <FormControl variant="outlined" size="small">
            <InputLabel id="filter-type-label">Filter</InputLabel>
            <Select
              labelId="filter-type-label"
              id="filter-type-select"
              value={filterType}
              onChange={handleFilterChange}
              label="Filter"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Outfitters">Outfitters</MenuItem>
              <MenuItem value="Sportsmen">Sportsmen</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small">
            <InputLabel id="sort-label">Sort By</InputLabel>
            <Select
              labelId="sort-label"
              id="sort-select"
              value={sortOrder}
              onChange={handleSortChange}
              label="Sort By"
            >
              <MenuItem value="Newest">Newest</MenuItem>
              <MenuItem value="Oldest">Oldest</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {filteredShowcases.map((showcase) => (
          <Grid item xs={12} md={6} lg={4} key={showcase.showcaseid}>
            <Card>
              <iframe
                title={showcase.title}
                src={showcase.video_url}
                style={{ width: '100%', height: '200px', border: 'none' }}
                allowFullScreen
              ></iframe>
              <CardContent>
                <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold' }}>
                  {showcase.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: '10px' }}>
                  {showcase.description}
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: '10px' }}>
                  <strong>{showcase.type === 0 ? 'Outfitter' : 'Sportsman'}:</strong> {showcase.outfitter_name}
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: '10px' }}>
                  <strong>Date:</strong> {new Date(showcase.created_at).toLocaleDateString()}
                </Typography>
                {showcase.outings.length > 0 && (
                  <Box>
                    <Typography variant="body2" color="textSecondary" style={{ fontWeight: 'bold' }}>
                      Outings:
                    </Typography>
                    {showcase.outings.map((outing) => (
                      <Button
                        key={outing.outingid}
                        variant="text"
                        color="primary"
                        href={`/outing?outingid=${outing.outingid}`}
                        style={{ textTransform: 'none', margin: '5px 0' }}
                      >
                        {outing.outing_name}
                      </Button>
                    ))}
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box display="flex" justifyContent="center" mb={4}>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setOpenModal(true)}
        sx={{
          textTransform: 'none',
          fontWeight: 'bold',
          px: 4,
          py: 1.5,
          marginTop: "20px",
          backgroundColor: '#de792c',
          '&:hover': {
            backgroundColor: '#5e3f1a',
          },
        }}
      >
        Apply to Be Featured on a Showcase
      </Button>
    </Box>

    <Modal open={openModal} onClose={() => setOpenModal(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      maxWidth: 800,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 2,
      borderRadius: 2,
      outline: 'none',
    }}
  >
    <Box display="flex" justifyContent="flex-end" >
      <IconButton onClick={() => setOpenModal(false)}>
        <CloseIcon />
      </IconButton>
    </Box>
    <iframe
      title="Apply to Be Featured"
      src="https://form.jotform.com/250461140377047"
      width="100%"
      height="600"
      frameBorder="0"
      style={{ border: 'none' }}
      allowFullScreen
    ></iframe>
  </Box>
</Modal>


    </Box>
    
  );
}

export default Showcases;
